import { Component, Plugin } from 'vue'
import { gtmPlugin } from './gtm'
import { i18nPlugin } from './i18n'
import { directives } from './directives'
import { component } from './fontawesome'

export const plugins: Array<Plugin> =
  gtmPlugin
    ? [i18nPlugin, gtmPlugin]
    : [i18nPlugin]

export { directives }

export const components: Record<string, Component> = { ...component }
